const minTitleLength = 1;
const maxTitleLength = 120; // This is an assumption!
const maxModularScale = 5;

function linearTransform(titleLength: number, isSmallScreen = false): number {
  const minModularScale = isSmallScreen ? 2 : 4;

  if (titleLength > maxTitleLength) {
    return minModularScale;
  }

  return Math.round(
    ((titleLength - minTitleLength) / (maxTitleLength / minTitleLength)) *
      (minModularScale - maxModularScale) +
      maxModularScale
  );
}

export default linearTransform;
